import { ITopTeamState } from '@app/ngrx/top-team/states/top-team.state';
import { createReducer, on } from '@ngrx/store';
import * as teamActions from '../actions';

const topTeamInitialState: ITopTeamState = {
  loading: false,
  loaded: false,
  topTeam: [],
  totalCount: 0,
};

export const topTeamReducer = createReducer(
  topTeamInitialState,
  on(teamActions.getTopTeam, teamActions.getMoreTopTeam, (state) => ({ ...state, loading: true, loaded: false })),
  on(teamActions.getTopTeamSuccess, (state, { topTeam, totalCount }) => {
    return { ...state, loading: false, loaded: true, topTeam, totalCount };
  }),
  on(teamActions.getMoreTopTeamSuccess, (state, { topTeam, totalCount }) => {
    return { ...state, loading: false, loaded: true, topTeam: [...state.topTeam, ...topTeam], totalCount };
  }),
  on(teamActions.getTopTeamFailure, teamActions.getMoreTopTeamFailure, (state) => ({ ...state, loading: false, loaded: false })),
);
